import { render, staticRenderFns } from "./Nagusi.vue?vue&type=template&id=6430d6c5&scoped=true&lang=true&"
import script from "./Nagusi.vue?vue&type=script&lang=js&"
export * from "./Nagusi.vue?vue&type=script&lang=js&"
import style0 from "./Nagusi.vue?vue&type=style&index=0&id=6430d6c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6430d6c5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
